/**
 * ReadReceiptMode
 *
 * The four states an own-message read receipt can be in. Mirrors the four
 * branches Flutter renders inline at `chat_screen.dart:2252-2293`:
 *  - `failed`         → send failed icon.
 *  - `notYetSeen`     → grey check; bubble hasn't been read yet (or no own
 *                       message has ever been read).
 *  - `lastReadAvatar` → peer avatar on the most-recent own message the peer
 *                       has read.
 *  - `spacer`         → fixed-size empty slot on every other own bubble so the
 *                       row width stays stable.
 *
 * Computed once per own message by `ChatMessagesList` (via
 * `ChatUtils.getReadReceiptMode`) and threaded down to `ReadReceiptAvatar` as
 * a primitive — replaces the previous `index + allMessages + myLastReadPosition`
 * triplet.
 *
 * Promoted from a co-located `chatUtils.ts` enum per `conventions.md` §
 * "Enums live in the domain layer".
 */

export enum ReadReceiptMode {
  failed = 'failed',
  notYetSeen = 'notYetSeen',
  lastReadAvatar = 'lastReadAvatar',
  spacer = 'spacer',
}
